module.exports = __webpack_public_path__ + "img/headimg.3ebaa2c0.svg";